<template>
	<div class="payout_details pa-4 pa-md-5 rounded-lg d-flex flex-column ga-3">

		<div class="d-flex justify-space-between">
			<span class="payout_details__key">
				Withdrawal amount
			</span>
			<span class="payout_details__value">
				{{ selectedDenomination?.currency }} {{ selectedDenomination?.currency_amount }}
			</span>
		</div>


		<div class="d-flex justify-space-between">
			<span class="payout_details__key">
				Coin costs
			</span>
			<span class="payout_details__value">
				{{ selectedDenomination?.coins_amount }}
			</span>
		</div>


		<div>
			<div :class="[
					'captcha-container justify-center align-center align-self-start rounded-8 overflow-hidden',
					isRecaptchaCompleted ? 'd-none' : 'd-flex'
				]">
				<div id="recaptcha" class="recaptcha"></div>
			</div>
			<v-btn rounded="pill" class="button--primary payout_details__button w-100 py-6 d-flex text-none" @click="processPayoutClicked"
				:loading="processingPayout" v-if="isRecaptchaCompleted">
				Withdraw
			</v-btn>
		</div>

	</div>
</template>



<script setup>

/* global grecaptcha */

import { AppConfigs } from '@/app.configs.ts'
import { PayoutStore } from '@/store/PayoutStore';
import { computed, ref, onMounted } from 'vue';

const emit = defineEmits(['processPayoutClicked'])

const payoutStore = PayoutStore();
const isRecaptchaCompleted = ref(false)

const processingPayout = computed(() => {
	return payoutStore.ProcessingPayout;
});

const selectedDenomination = computed(() => {
	return payoutStore.SelectedDenomination || {};
});

const recaptchaCompleted = (response) => {
	isRecaptchaCompleted.value = true
}

const processPayoutClicked = () => {
	emit('processPayoutClicked')
}

onMounted(() => {
	try {
		grecaptcha.render('recaptcha', {
			'sitekey': AppConfigs.googleReCaptchaSiteKey,
			'callback': recaptchaCompleted,
			'expired-callback': () => {
				isRecaptchaCompleted.value = false;
			},
			'error-callback': () => {
				isRecaptchaCompleted.value = false;
			}
		});
	} catch (error) {
		console.error('Error rendering reCAPTCHA:', error);
		isRecaptchaCompleted.value = false;
	}
})

</script>